import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1rem'
        }}>
          <div style={{
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #003399',
            borderRadius: '50%',
            width: '60px',
            height: '60px',
            animation: 'spin 0.8s linear infinite'
          }}></div>
          <p style={{ color: '#666', fontWeight: 500 }}>Checking authentication...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/ft-portal/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
